export default __webpack_public_path__ + "static/media/icon_financial-reports.e721ab10.svg";